import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { ValidatorContract } from "utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "utils/Environment";
import { ethers } from "ethers";

const SendClaim = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const validatorAddress = Environment.ValidatorContract;
  const validatorContract = ValidatorContract(validatorAddress, web3);

  const claim = useCallback(
    async (tokenId, amount, nextClaimedAt, deadline, signature) => {
      try {
        // const gas = await validatorContract?.methods
        //   ?.claim(tokenId, amount, deadline, signature)
        //   ?.estimateGas({ from: account });
        // console.log(gas, "gassssss");
        const transaction = await validatorContract.methods
          .claim(tokenId, amount, nextClaimedAt, deadline, signature)
          .send({ from: account });

        console.log("Claim transaction successful: ", transaction);

        return transaction;
      } catch (error) {
        console.error(
          `Error during claim transaction for tokenId ${tokenId}: `,
          error
        );
        throw error; // Optional: rethrow to handle it in the caller
      }
    },
    [validatorContract, account]
  );

  return { claim: claim };
};

export default SendClaim;
